import { msg, react } from "../../../omnia"
import { dispatchSetSelection } from "../../actions"
import { TerramapContext } from "../../context"
import { DateFilter, Filters, getDateFilterOptions } from "../../filters"
import { State } from "../../state"
import { SoilOptixSet } from "../../types"

interface Props {
    state: State
}

const dateComparisonOptions: [DateFilter["comparison"], string][] = [
    ["in", "In"],
    ["since", "Since"],
    ["before", "Before"]
]

export function Filters({ state }: Props) {

    const { selection: { filters } } = state
    const { date, setId } = filters

    const { dates, selectDate, selectDateComparison, setIds, selectSetId } = useFilters(state)

    return <div className="section grey filters">

        <react.FormGroupSelectNumber className="set" value={setId} options={setIds} setValue={selectSetId} defaultLabel={msg("(Set id)")} />

        <div className="date">

            {
                Boolean(date?.date) &&
                <react.FormGroupSelect value={date.comparison} options={dateComparisonOptions} setValue={selectDateComparison} />
            }

            <react.FormGroupSelectNumber value={date?.date} options={dates} setValue={selectDate} defaultLabel={msg("(Year/month)")} />

        </div>

    </div>

}

function useFilters(state: State) {

    const { dispatch, api } = React.useContext(TerramapContext)
    const { sets, layers, selection } = state
    const { filters } = selection

    const set = (update: Partial<Filters>) => {
        dispatchSetSelection(dispatch, api, state, { ...filters, ...update })
    }

    const dates = React.useMemo(() => getDateFilterOptions(layers), [layers])
    const selectDate = (date: number) => set({ date: date ? { date, comparison: filters.date?.comparison ?? "in" } : undefined })
    const selectDateComparison = (cmp: DateFilter["comparison"]) => set({ date: { date: filters.date.date, comparison: cmp } })

    const setIds = React.useMemo(() => getSetIdOptions(sets), [sets])
    const selectSetId = (setId: number) => set({ setId })

    return {

        dates,
        selectDate,
        selectDateComparison,

        setIds,
        selectSetId

    }

}

function getSetIdOptions(sets: SoilOptixSet[]): [number, string][] {
    const ids = sets.map(s => s.setId).sort((a, b) => b - a)
    return ids.map(id => [id, String(id)])
}
